import moment from "moment";
import "./ConversationDateSeparator.scss";

// Localised day label for the divider. Intl rather than a moment format string
// because moment has no "month + day, no year" token that reorders per locale
// ("March 17" vs "17. März"). moment.locale() is already set from the widget
// language in Stores/Config, so both stay in sync.
const formatSeparatorLabel = (date: moment.Moment): string => {
  const options: Intl.DateTimeFormatOptions = date.isSame(moment(), "year")
    ? { month: "long", day: "numeric" }
    : { month: "long", day: "numeric", year: "numeric" };

  try {
    return new Intl.DateTimeFormat(moment.locale(), options).format(
      date.toDate(),
    );
  } catch {
    // Unknown locale tag — moment's own localised long date is the safe net.
    return date.format("LL");
  }
};

// Centred day divider between messages sent on different days. Without it a
// thread that spans weeks reads as one continuous conversation, since the only
// other time cue is a relative timestamp on the last message of each group.
export const ConversationDateSeparator = ({
  date,
}: {
  date: string | Date;
}) => {
  const value = moment(date);
  if (!value.isValid()) {
    return null;
  }

  return (
    <div className="conversation-date-separator">
      {formatSeparatorLabel(value)}
    </div>
  );
};
